import React, { Fragment } from 'react';
import styles from './UseOfForceInformation.module.scss';
import {
  ConfigBase,
  Field,
  FieldValueType,
  UseOfForceValueType
} from '../../../../../Models';
import { FieldItem } from '../../CommonBody/FieldItem/FieldItem';
import { getFieldType } from '../../CommonBody/Helpers';

// Just for rendering conditional fields inside Use of Force section - 1 level only
const renderConditionalFields = (
  field: Field,
  value: UseOfForceValueType
): JSX.Element | undefined => {
  if (!field.condition_if || field.condition_if.length === 0) {
    return undefined;
  }

  for (let conditional of field.condition_if) {
    if (
      (conditional as any).selected_option === value[field.name] ||
      (conditional as any).selected_option === value[field.name]?.toString()
    ) {
      return (conditional as any).fields.map((nestedField: Field) => {
        if (value[nestedField.name]) {
          return (
            <FieldItem
              key={nestedField.name}
              label={nestedField.label}
              value={value[nestedField.name] as FieldValueType}
              type={getFieldType(nestedField)}
            />
          );
        }
        return undefined;
      });
    }
  }
  return undefined;
};

export interface UseOfForceInformationProps {
  useOfForce: UseOfForceValueType;
  config: ConfigBase;
}

export const UseOfForceInformation = ({
  useOfForce,
  config
}: UseOfForceInformationProps): React.ReactElement<UseOfForceInformationProps> => {
  const useOfForceFields: Field[] = config.sections[0].fields;
  return (
    <div className={styles.useOfForceInformation}>
      <h3 className={styles.title}>{config.title}</h3>
      <div className={styles.items}>
        {useOfForceFields.map((field, index): JSX.Element | undefined => {
          if (useOfForce[field.name]) {
            return (
              <Fragment key={`${field.name}-${index}`}>
                <FieldItem
                  key={field.name}
                  label={field.label}
                  value={useOfForce[field.name] as FieldValueType}
                  type={getFieldType(field)}
                />
                {renderConditionalFields(field, useOfForce)}
              </Fragment>
            );
          }

          return undefined;
        })}
      </div>
    </div>
  );
};
